import tileBolognaCentrale01 from "assets/easy/AV_BOLOGNA_CENTRALE/01.jpg";
import tileBolognaCentrale02 from "assets/easy/AV_BOLOGNA_CENTRALE/02.jpg";
import tileBolognaCentrale03 from "assets/easy/AV_BOLOGNA_CENTRALE/03.jpg";
import tileBolognaCentrale04 from "assets/easy/AV_BOLOGNA_CENTRALE/04.jpg";
import tileBolognaCentrale05 from "assets/easy/AV_BOLOGNA_CENTRALE/05.jpg";
import tileBolognaCentrale06 from "assets/easy/AV_BOLOGNA_CENTRALE/06.jpg";
import tileBolognaCentrale07 from "assets/easy/AV_BOLOGNA_CENTRALE/07.jpg";
import tileBolognaCentrale08 from "assets/easy/AV_BOLOGNA_CENTRALE/08.jpg";
import tileBolognaCentrale09 from "assets/easy/AV_BOLOGNA_CENTRALE/09.jpg";
import tileBolognaCentrale10 from "assets/easy/AV_BOLOGNA_CENTRALE/10.jpg";
import tileBolognaCentrale11 from "assets/easy/AV_BOLOGNA_CENTRALE/11.jpg";
import tileBolognaCentrale12 from "assets/easy/AV_BOLOGNA_CENTRALE/12.jpg";
import tileBolognaCentrale13 from "assets/easy/AV_BOLOGNA_CENTRALE/13.jpg";
import tileBolognaCentrale14 from "assets/easy/AV_BOLOGNA_CENTRALE/14.jpg";
import tileBolognaCentrale15 from "assets/easy/AV_BOLOGNA_CENTRALE/15.jpg";
import tileBolognaCentrale16 from "assets/easy/AV_BOLOGNA_CENTRALE/16.jpg";
import fullImage from "assets/easy/AV_BOLOGNA_CENTRALE/complete.jpg";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const bolognaCentrale: ILevel = {
  difficulty: LevelDifficulties.easy,
  type: LevelTypes.station,
  name: "AV Bologna Centrale",
  fullImage,
  successDialogContent: {
    subtitle: "Hai (ri)costruito la stazione AV BOLOGNA CENTRALE",
    link: `https://www.fsitaliane.it/content/fsitaliane/it/innovazione/tecnologie-per-i-trasporti/le-principali-stazioni-av/bologna-centrale-av.html`,
    contents: [
      {
        text: "In perfetto equilibrio tra innovazione e tradizione",
        isBold: true,
      },
      {
        text:
          ", la stazione AV Bologna Centrale è caratterizzata da un “camerone” interrato che si sviluppa su ",
        isBold: false,
      },
      {
        text: "tre livelli collegati da un sistema di scale e ascensori",
        isBold: true,
      },
      {
        text:
          ": il piano AV, sede dei quattro binari dedicati all’Alta Velocità, il piano intermedio e il piano kiss&ride. Un ",
        isBold: false,
      },
      {
        text: "complesso armonico e avveniristico",
        isBold: true,
      },
      {
        text:
          " che ha consentito di incrementare i volumi di traffico, rendere la ",
        isBold: false,
      },
      {
        text: "circolazione più regolare",
        isBold: true,
      },
      {
        text: ", ricucire il tessuto urbano e ",
        isBold: false,
      },
      {
        text: "collegare il quartiere Bolognina al centro storico",
        isBold: true,
      },
      {
        text:
          ". La stazione rappresenta la chiave di volta di tutto il progetto di ",
        isBold: false,
      },
      {
        text: "potenziamento del nodo ferroviario",
        isBold: true,
      },
      {
        text: " di Bologna.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tileBolognaCentrale01,
    tileBolognaCentrale02,
    tileBolognaCentrale03,
    tileBolognaCentrale04,
    tileBolognaCentrale05,
    tileBolognaCentrale06,
    tileBolognaCentrale07,
    tileBolognaCentrale08,
    tileBolognaCentrale09,
    tileBolognaCentrale10,
    tileBolognaCentrale11,
    tileBolognaCentrale12,
    tileBolognaCentrale13,
    tileBolognaCentrale14,
    tileBolognaCentrale15,
    tileBolognaCentrale16,
  ],
};
